var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    light: _vm.light && !_vm.readOnly
  },style:({
    height: _vm.defaultHeight ? _vm.defaultHeight + 'px' : '100%',
    width: '100%'
  }),attrs:{"id":"model-container"}},[_c('model-viewer',{attrs:{"id":"model-viewer","loading":"eager","camera-controls":"","src":_vm.previewUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }